/** Page arithmetic, kept out of the component so it can be tested without
 *  rendering anything. */

/** How many pages `total` rows make at `perPage` each, never fewer than one.
 *
 *  The remainder matters: 4,462 organisations at 40 a page is 111 full pages
 *  and 22 left over, and flooring strands them. */
export function pageCount(total: number, perPage: number): number {
  return Math.max(1, Math.ceil(total / perPage));
}

/** The row a page starts at.
 *
 *  The page number arrives off the URL, where anyone can type. The API
 *  rejects a negative offset, so a typo would empty the list rather than
 *  merely mis-scroll it. */
export function offsetFor(page: number, perPage: number): number {
  return Math.max(0, (Math.floor(page) || 1) - 1) * perPage;
}
